import React from "react";
import Select from "react-select";
import { Modal, Spinner } from "reactstrap";

const EmergencyStudentModal = ({ show, loading, formData2, setFormData2, allStudents, compStudents, timeSlots, onSubmit, onClose }) => {
  if (!show) return null;
  const studentOptions = !formData2.bookingType ? [] : formData2.bookingType === "Comp" ? compStudents : allStudents;

  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static" keyboard={false}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            Add Emergency Student
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={onClose}
          />
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label">
                  Booking Type*
                </label>

                <Select
                  placeholder="Select Booking Type"
                  options={[
                    { value: "Fixed", label: "Fixed" },
                    { value: "Comp", label: "Comp" },
                  ]}
                  value={
                    formData2.bookingType
                      ? {
                        value: formData2.bookingType,
                        label: formData2.bookingType,
                      }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setFormData2({
                      ...formData2,
                      bookingType: selectedOption?.value || "",
                      studentId: "",
                    })
                  }
                  required
                  isClearable
                  classNamePrefix="select2-selection"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Student*
                </label>
                <Select
                  placeholder={
                    formData2.bookingType
                      ? "Select Student"
                      : "Select Booking Type First"
                  }
                  options={studentOptions.map((student) => ({
                    value: student.Id,
                    label: student.Student_Name,
                  }))}
                  value={
                    studentOptions
                      .map((student) => ({
                        value: student.Id,
                        label: student.Student_Name,
                      }))
                      .find(
                        (option) =>
                          option.value === formData2.studentId
                      ) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData2({
                      ...formData2,
                      studentId: selectedOption?.value || "",
                    })
                  }
                  required
                  isClearable
                  classNamePrefix="select2-selection"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Batch Time*
                </label>
                <Select
                  placeholder="Select Batch"
                  options={timeSlots.map((slot) => {
                    const isClosedClass = Number(slot.IsClassCancelled) === 1;

                    return {
                      value: slot.Batch_Time,
                      label: `${slot.Batch_Time}${isClosedClass ? " (Closed Class)" : ""
                        }`,
                      isDisabled: isClosedClass,
                    };
                  })}
                  value={
                    timeSlots
                      .map((slot) => {
                        const isClosedClass = Number(slot.IsClassCancelled) === 1;

                        return {
                          value: slot.Batch_Time,
                          label: `${slot.Batch_Time}${isClosedClass ? " (Closed Class)" : ""
                            }`,
                        };
                      })
                      .find((option) => option.value === formData2.batchTime) || null
                  }
                  onChange={(selectedOption) =>
                    setFormData2({
                      ...formData2,
                      batchTime: selectedOption?.value || "",
                    })
                  }
                  required
                  isClearable
                  classNamePrefix="select2-selection"
                />
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default EmergencyStudentModal;